(function ($) {
    

	/* Document Ready */
	$(document).ready(function() {
        
        if($('.product-detail-tabs').length){
            var firstObj = $('.product-detail-tabs').find('li').first().attr('data-tabname');

            $(".product-detail-tabs").find('li').each(function() {
                if( $(this).data('tabname') === firstObj) {
                    $(this).addClass('active');
                }
            });
            $(".product-detail-tabs-content").find('.product-detail-content').each(function() {
                if( $(this).attr('id') === firstObj) {
                    $(this).addClass('active');
                    $(this).find('.tab-mobile').addClass('active');
                }
            });


            $('.product-detail-tabs').find('li').on('click',function(e){
                var tabName = $(this).attr('data-tabname');
                
                // active deactivate tab buttons
                $('.product-detail-tabs li').removeClass('active');
                $(this).addClass('active');

                // show hide tab content
                $('.product-detail-content').removeClass('active');
                $(".product-detail-tabs-content #"+tabName).addClass('active');
                
                // show hide mobile tab content
                $('.product-detail-content').find('.tab-mobile').removeClass('active');
                $(".product-detail-tabs-content #"+tabName).find('.tab-mobile').addClass('active');

                // stop reload
                e.preventDefault();
            });
            
            $('.product-detail-tabs-content').find('.tab-mobile').on('click',function(e){
                var mobileName = $(this).parent().attr('id');
//                alert(mobileName);
                
                // active deactivate tab buttons
                $('.product-detail-tabs li').removeClass('active');
                $('.product-detail-tabs').find('[data-tabname="' + mobileName + '"]').addClass('active');

                // show hide tab content
                $('.product-detail-content').removeClass('active');
                $(".product-detail-tabs-content #"+mobileName).addClass('active');
                
                // show hide mobile tab content
                $('.product-detail-content').find('.tab-mobile').removeClass('active');
                $(this).addClass('active');

                // stop reload
                e.preventDefault();
            });
        }

	});

})(jQuery);